import { calcWidth } from '../../../utils/dimensions';

export const POST_BITE_HORIZONTAL_PADDING = calcWidth(30);
export const POST_BITE_TOGGLE_ICON_WIDTH = calcWidth(26);
export const POST_BITE_TOGGLE_ICON_END_MARGIN = calcWidth(15);
